<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title">
        <icon-approval-doc />
        결재자를 확인하세요.
      </v-col>
    </v-row>

    <div class="overflow-y-auto">
      <!-- 결재레벨 & 결재선변경 -->
      <appl-line-select></appl-line-select>

      <!-- 결재자 -->
      <v-row class="title-wrap">
        <v-col class="bg-title">결재자</v-col>
      </v-row>
      <!-- 결재자 리스트 -->
      <v-row class="ma-0">
        <v-col cols="12" class="pl-6 pr-0 pb-5">
          <appl-line></appl-line>
        </v-col>
      </v-row>

      <!-- 참조자  -->
      <!--<v-row class="title-wrap">
        <v-col class="bg-title justify-space-between">
          참조자
          <v-btn
            elevation="0"
            text
            fab
            width="24"
            height="24"
            mt-n1
            v-show="GET_APPL_SEQ_EXIST == 'N'"
            @click="openModal('add_referrer')"
          >
            <v-icon size="24" color="#777e87">mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row class="ma-0">
        <v-col cols="12" class="px-6 pt-1 pb-5">
          <refer-line></refer-line>
        </v-col>
      </v-row>
    -->
      <v-row class="title-wrap">
        <v-col class="bg-title justify-space-between">
          담당자
          <v-btn
            elevation="0"
            text
            fab
            width="24"
            height="24"
            mt-n1
            v-show="GET_APPL_SEQ_EXIST == 'N' && GET_UI_INFO.appPathYn == 'Y'"
            @click="openModal('add_mgrrer')"
          >
            <v-icon size="24" color="#777e87">mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <!-- 담당자 리스트 -->
      <v-row class="ma-0">
        <v-col cols="12" class="px-6 pt-1 pb-5">
          <mgr-line></mgr-line>
        </v-col>
      </v-row>
    </div>
    <!---------------------------------------------------------------------------->
    <!-- [모달] 참조자추가 -->
    <add-referrer-dialog
      :referUserListProps="referUserListProps"
    ></add-referrer-dialog>

    <add-mgrrer-dialog :mgrUserListProps="mgrUserListProps"></add-mgrrer-dialog>
  </div>
</template>

<script>
/* 신청서 결재선공통 (결재레벨 / 결재자 / 참조자) */
import ApplLineSelect from '@/components/application/form/ApplLineSelect.vue'; // 결재선선택 component
import ApplLine from '@/components/application/form/ApplLine.vue'; // 결재선 component
//import ReferLine from '@/components/application/form/ReferLine.vue'; // 참조자 component
import AddReferrerDialog from '@/components/application/dialog/AddReferrerDialog.vue'; // 참조자추가 modal component
import IconApprovalDoc from '@/assets/customIcon/IconApprovalDoc.vue'; // icon svg
import MgrLine from '@/components/application/form/MgrLine.vue'; // 담당자 component
import AddMgrrerDialog from '@/components/application/dialog/AddMgrrerDialog.vue'; // 담당자 modal component

import { mapGetters } from 'vuex';
import { getApplLine } from '@/api/ela';

export default {
  data: () => ({
    referUserListProps: [],
    mgrUserListProps: [],
  }),

  computed: {
    ...mapGetters('ELA', [
      'GET_APPL_SEQ_EXIST',
      'GET_REFER_USER_LIST',
      'GET_MGR_USER_LIST',
      'GET_UI_INFO',
      'GET_APPL_USER_LIST',
      'GET_ELA_APPL_PARAM',
    ]),

    ...mapGetters(['GET_USER_DATA']),
    ...mapGetters('DIALOG', ['GET_DIALOG_PARAM']),
  },

  methods: {
    /* 모달호출 */
    openModal(modalNm) {
      this.$store.commit('DIALOG/TOGGLE_MODAL', modalNm);

      if (modalNm == 'add_referrer') {
        // 참조자리스트 copy 생성
        this.referUserListProps = [];
        this.GET_REFER_USER_LIST.forEach(item => {
          this.referUserListProps.push(item);
        });
      }
      if (modalNm == 'add_mgrrer') {
        // 담당자리스트 copy 생성
        for (let i=0; i<this.GET_MGR_USER_LIST.length; i++) {
          this.GET_MGR_USER_LIST[i].agreeSeq = this.GET_APPL_USER_LIST.length + this.GET_MGR_USER_LIST.length + 1;
        }
        this.mgrUserListProps = [];
        this.GET_MGR_USER_LIST.forEach(item => {
          this.mgrUserListProps.push(item);
        });
      }
    },
  },

  components: {
    IconApprovalDoc,
    ApplLineSelect,
    ApplLine,
    //ReferLine,
    AddReferrerDialog,
    MgrLine,
    AddMgrrerDialog,
  },
};
</script>

<style>
/* _approval.scss 에 넣음 */
/* dialog */
/* .v-dialog:not(.v-bottom-sheet) {
  background-color: white;
  height: inherit;
} */
</style>
